<template>
  {{ $t("issueSelector.filter.advanced") }}
</template>
